module.exports = __webpack_public_path__ + "static/media/a6_postkarte_back.b6da075e.jpg";